import { css } from '@emotion/react'
import Colors from '../../utils/colors'

const Styles = ({ colors }) => {
  const { broker } = Colors()
  const { scales: { grayShades, green } } = colors

  return ({
    cardContent: css` 
      display: flex; 
      flex-direction:row;
      justify-content: flex-start;
      align-items: center;
      margin-bottom: 1.25rem;
      &:first-of-type{
        h1:first-of-type, h2:first-of-type {
          padding-right: 2.25rem;
        }
      }
      @media (max-width:768px) {
        margin-bottom: 1.5rem
      }
    `,
    indexStyle: css`
      color: ${broker} !important;
      padding-right: 1.625rem;
    `,
    titleStyle: css`
      color: ${broker} !important;
      padding-bottom: .625rem;
    `,
    littleText: css`
      color: ${grayShades[6]} !important;
      margin: .438rem 0 0
    `,
    mainContainer: css`
      text-align: center;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 17.375rem;
      justify-conten: center;
      @media (max-width: 768px) { 
        margin: 0 0 1.75rem;
      }
    `,
    animatedContainer: css`
      text-align: center;
      margin-top: -2rem;
      @media (max-width: 768px) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        width: 100%;

      }
    `,
    dataContainer: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-around;
      cursor: pointer;
      text-align: center;
      padding: 1.5rem !important;
      height: 22rem !important;
      a {
        text-decoration: none;
      }
      img {
        margin-bottom: 1.875rem;
      }
      @media (max-width: 768px) {
        height: 26rem !important;
      }
    `,
    link: css`
      text-decoration: none;
    `,
    amountStyle: css`
      color: ${green[5]} !important;
      display: inline-block;
    `,
    styleTitle: css`
      margin-top: -3.5rem !important;
      @media(max-width: 768px){
        margin-top: -2rem !important;
      }
    `
  })
}

export { Styles }
